package fr.labodoc.healthProfessional.webApp.pages.learnedSocieties

import io.kvision.core.StringPair
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow

sealed class LearnedSocietiesPageViewModel {
  data class LearnedSociety(
    val id: String,
    val name: String,
    val websiteUrl: String,
    val logoUrl: String?,
    val favorite: Boolean,
    val forExterns: Boolean,
    val medicalSpecialityIds: Set<String>,
  )

  sealed class Filter {
    data object All : Filter()
    data object Favorites : Filter()

    data object MySpeciality : Filter()

    data class MedicalSpecialities(val medicalSpecialityIds: Set<String>) : Filter()
  }

  sealed class LearnedSocietiesList {
    data object Loading : LearnedSocietiesList()

    data object Error : LearnedSocietiesList()

    data class Loaded(
      val learnedSocieties: List<LearnedSociety>
    ) : LearnedSocietiesList()
  }

  sealed class Event {
    data class UpdateFavoriteStatusFailed(
      val learnedSociety: LearnedSociety
    ) : Event()
  }

  abstract val filter: StateFlow<Filter>

  abstract val medicalSpecialityFilterOptions: StateFlow<Map<String?, List<StringPair>>>

  abstract val learnedSocietiesListState: StateFlow<LearnedSocietiesList>

  abstract val events: SharedFlow<Event>

  abstract fun refreshMedicalSpecialityFilterOptions()

  abstract fun refreshLearnedSocieties()

  abstract fun updateFilter(filter: Filter)

  abstract fun updateFavoriteStatus(learnedSociety: LearnedSociety)
}
